
if(!customElements.get('facet-remove')){
    class FacetRemove extends HTMLElement {
        constructor(){
            super();

            this.form = this.closest('.facets');
            this.link = this.querySelector('a');
            this.url = this.link?.getAttribute('href');
        }

        connectedCallback(){
            this.link.addEventListener("click", this.removeFacet.bind(this));
        }

        removeFacet(e){
            if(!this.url || !this.form) return;
            e.preventDefault();

            this.form.handleFilterUpdateByUrl({ 
                url: this.url, 
                callback: () => {
                    const filterDrawer = document.querySelector('filter-drawer');
                    if(filterDrawer){
                        filterDrawer.handleFilterUpdate();
                    }
                }
            });
        }
    }

    customElements.define('facet-remove', FacetRemove);
}